import {useMemo} from "react";
import {useGetStimmenListe} from "../../client/hooks";
import {useQuery} from "react-query";
import {StimmenListe} from "../../api";
type Stimme = { id: string; name: string };
export function useStimmenHandling(values: { stimmeId?: string }){
    const { data: stimmenListe, isLoading } = useStimmenListeQuery();
    const stimmenOptions = useMemo(() => stimmenListe?.stimmen ?? [], [stimmenListe?.stimmen]);
    const selectedStimme = useMemo(() => {
                if (isLoading) return {id: "", name: "Lade..."};

                    const stimmeValue = values?.stimmeId;

                    if (!stimmeValue) {
                        return stimmenOptions.length > 0
                           ? stimmenOptions[0]
                               : {id: "", name: ""};
                    }

                    const foundOption = stimmenOptions.find((option:Stimme) => option.id === stimmeValue);

                    return foundOption ?? {id: stimmeValue, name: stimmeValue};
            }, [values?.stimmeId, isLoading, stimmenOptions]);


    return{
        stimmenOptions,
        selectedStimme,
        isLoading
    }
}
function useStimmenListeQuery() {
    const getStimmenListe = useGetStimmenListe();

    return useQuery<StimmenListe>({
        queryKey: ["stimmenListe"],
        queryFn: getStimmenListe,
    });
}